<template>
  <q-option-group
    :value="value"
    :options="options"
    color="primary"
    inline
    dense
    size="2rem"
    @input="valueChanged($event, params.data, params)"
  />
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  computed: {
    value() {
      return this.params.value
    },

    options() {
      return this.params.options
    },

    valueChanged() {
      return this.params.valueChanged
    }
  }
})
</script>
